<template>
<div :class="$style.reminderWrapper">
    <table>
        <thead>
            <tr>
                <th style="font-weight:500; font-size: 18px; color: black;">
                    {{$language()=='fr' ? 'RAPPELS POUR CE PATIENT' : 'reminders for this patient'}}
                </th>
            </tr>
        </thead>

        <tbody>
            <tr>
                <td>
                    <ul :class="$style.reminderUl">
                        <li v-for="(reminder, index) in reminders" v-html="reminder" :key="'reminder_'+index"/>
                    </ul>
                </td>
            </tr>
        </tbody>
    </table>
</div>
</template>

<script>
export default {
    props: {
        selections: {
            type: Array,
            required: true
        }
    },
    computed: {
        reminders: function(){
            let selections = this.selections;
            let reminders = {};
            let map = {
                1: {
                    en:"Diagnosis should be confirmed by spirometry.",
                    fr: "Le diagnostic devrait être confirmé par spirométrie."    
                },
                2: {
                    en:"Pneumococcal vaccination should be completed.",
                    fr: "On devrait administrer un vaccin antipneumococcique."    
                },
                3: {
                    en:"Seasonal influenza vaccination should be completed.",
                    fr: "On devrait administrer un vaccin antigrippal saisonnier."    
                },
                4: {
                    en:"Pulmonary rehabilitation should be completed.",
                    fr: "Une réadaptation pulmonaire devrait être effectuée."    
                },
                5: {
                    en:"Training on current inhaler technique with their current device should be completed.",
                    fr: "On devrait vérifier la technique d’inhalation avec le dispositif actuel."    
                },
                6: {
                    en:"No specific reminders for this patient. Be sure to complete annual seasonal influenza vaccination.",
                    fr: "Aucun rappel spécifique pour ce patient. Il ne faut pas oublier d’administrer un vaccin antigrippal saisonnier annuel."    
                },
                7: {
                    en:"Continue to assess this patient for new or worsening symptoms and acute exacerbations of COPD.",
                    fr: "Il faut continuer d’évaluer ce patient pour détecter tout nouveau symptôme ou aggravation des symptômes et exacerbations aiguës de la MPOC."    
                }
            }
            let allChecked = true;
            for(let value=1; value<=5; value++){
                if(!this.$root.in_array(value,selections)){
                    reminders[value] = map[value][this.$language()];
                    allChecked = false;
                }
            }
            if(allChecked){
                reminders[6] = map[6][this.$language()];
            }
            reminders[7] = map[7][this.$language()];
            return reminders;
        }
    }
}
</script>


<style module>
.reminderWrapper {
    border: 3px solid #ffc423;
}

.reminderWrapper table {
    width:100%; 
    max-width:800px; 
    margin: 0 auto; 
    padding: 2% 0;
}

.reminderWrapper table thead tr th {
    font-weight: 500;
    font-size: 18px; 
    color: black;
}

.reminderWrapper table tbody {
    margin-top: 2%;
}

.reminderUl {
    line-height: 2;
    font-weight: 300;
    font-size: 16px;
    color: black;
}

</style>

<style scoped>
th{
    text-transform: uppercase;
}
</style>